import { setGlobalCSSVar } from 'css/vars';

// Endpoints
export const END_POINT = process.env.REACT_APP_BACKEND;
export const PUBLIC_URL = process.env.PUBLIC_URL || '/.';
setGlobalCSSVar('--public-url', PUBLIC_URL);

// AsyncAPI reconnection settings
export const RECONNECT_ATTEMPTS1 = 7; // # of attempts with delay 1
export const RECONNECT_DELAY1 = 1_000; // delay for first number of attempts
export const RECONNECT_NOTIFY = 3; // notify the user after these attempts
export const RECONNECT_ATTEMPTS2 = 20; // total attempts to make
export const RECONNECT_DELAY2 = 10_000; // delay for second number of attempts
export const RECONNECT_DELAY3 = 3 * 60 * 1000; // final delay attempts, 3 minutes

export const VERIFY_TOKEN_INTERVAL = 2 * 60 * 1000; // 2 minutes
export const VERIFY_MAINTENANCE_INTERVAL = 1 * 60 * 1000; // 1 minute

// Environment flags
export const IS_DEV: boolean = process.env.NODE_ENV === 'development';
export const IS_TEST: boolean = ['development', 'test'].includes(
  process.env.NODE_ENV || '',
);
export const IS_PRODUCTION: boolean = process.env.NODE_ENV === 'production';

// URL slugs used in routing
export const SLUGS = {
  LOGIN: 'login',
  SIGNUP: ['signup', 'inschrijven'],
  RESETPWD: 'resetpwd',
  VERIFYMAIL: 'verifymail',
  PROFILE: ['profile', 'profiel'],
  // Localization
  EN: 'en',
  NL: 'nl',
  // The slugs below are used as filenames in public/html
  FRONT: 'frontpage',
  CONTACT: 'contact',
  // Admin pages
  SITE_CONFIG: 'config',
  ADMIN_MAINTENANCE: 'admin/maintenance',
  // Specific pages
  PROJECTS: 'projects',
  PUBLICATIONS: 'publications',
  TEAM: 'team',
  LIBRARY: 'library',
};
type SlugValue = (typeof SLUGS)[keyof typeof SLUGS];
export type Slug = SlugValue extends string
  ? SlugValue
  : SlugValue extends string[]
    ? SlugValue[number]
    : never;

// UI State persistence
export const PERSIST_DELAY_MS = (IS_DEV ? 15 : 2 * 60) * 1000; // 2 minutes, 15 seconds in dev

// Guest user management
export const INACTIVE_GUEST_TOLERANCE = 10; // keep the latest 10 inactive guests

// Constraints on file names
export const FORBIDDEN_FILENAME_CHARS = /[\/\\#\?!%\*\:<>\|\"&+]/g;
export const MAX_FILENAME_LENGTH = 200;

// Status options for projects, members, and publications
export const PROJECT_STATUSES = [
  'concept',
  'active',
  'finished',
  'archived',
] as const;
export const MEMBER_STATUSES = ['active', 'former'] as const;
export const PUBLICATION_STATUSES = [
  'concept',
  'published',
  'archived',
] as const;

// Canvas Zooming
export const CANVAS_ZOOM_RESET_DELAY = 800; // ms after which zoom reset can occur again
export const CANVAS_MIN_SCALE = 0.25; // best a plural of 0.25
export const CANVAS_MAX_SCALE = 3;
export const CANVAS_DEFAULT_SCALE = 1;
export const CANVAS_ZOOMFACTOR = 1.005;

export const CANVAS_ZOOMSNAP_STEP = 0.5;
export const CANVAS_ZOOMSNAP_FACTOR = 0.05;

export const CANVAS_ZOOMINCREMENT = 0.005;
export const CANVAS_ZOOMTHRESHOLD = 30 * CANVAS_ZOOMINCREMENT;

// Canvas layer font (for SVG built-in layers)
export const CANVAS_LAYER_FONT = 'roboto';
export const CANVAS_LAYER_FONTWEIGHT = 700;

// Notification settings
export const DAYPARTS = {
  MOR: 7, // Morning   ->  7:00
  AFT: 12, // Afternoon -> 12:00
  EVE: 17, // Evening   -> 17:00
};

// Supported locales
export const LOCALES = [
  'en',
  'nl',
  'de',
  'fr',
  'tr',
  'ar',
  'pt',
  'es',
] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'en';
